import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Nav, Row, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../../components/doctors/partials/Header';
import TopLeftMenu from '../../components/doctors/partials/topLeftMenu';
import LoadingButton from '../../components/forms/LoadingButton';
import { usePostRequest } from '../../hooks/usePostRequest';
import { useValidation } from '../../hooks/validationHooks/useValiation';
import {
  agePrint,
  capitalizeFirstLetter,
  separateDateTime,
  userRole,
} from '../../utils/helpers';
import { appointmentSchema } from '../../validationSchemas/appointment.validation';

import avatarMale from '../../assets/images/avatar_male.jpeg';
import avatarFemale from '../../assets/images/avatar_female.jpeg';
import WebcamCapture from '../../components/doctors/modals/WebcamCapture';
import BasicPatientForAppointment from '../../components/doctors/partials/basicPatientForAppointment';
import MedicalPatientForAppointment from '../../components/doctors/partials/medicalPatientForAppointment';
import OthersPatientInfo from '../../components/doctors/partials/othersPatientInfo';
import { useGetRequest } from '../../hooks/useGetRequest';
import { deleteRequest } from '../../utils/axiosRequests';
import { ReactComponent as BackArrow } from '../../assets/icons/arrow-square-left.svg';

function PatientHistory() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [backendError, setBackendError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOnExamination, setSelectedOnExamination] = useState({});

  const [patientPicture, setPatientPicture] = useState(null);
  const [patientInfo, setPatientInfo] = useState({});
  const [patientId, setPatientId] = useState('');
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [errors, setErrors] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [appointmentInfo, setAppointmentInfo] = useState({});
  const [appointmentDateTime, setAppointmentDateTime] = useState('');
  const [visitType, setVisitType] = useState('new');
  const [visitationFee, setVisitationFee] = useState('');
  const [patientType, setPatientType] = useState('new');
  const [balanceMessage, setBalanceMessage] = useState('');
  const [selectedChiefComplains, setSelectedChiefComplains] = useState([]);
  const [selectedInvestigations, setSelectedInvestigations] = useState([]);
  const [doctorPatientId, setDoctorPatientId] = useState([]);

  const validation = useValidation;

  const userInfo = useSelector((state) => state.authReducer.data);
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );
  const patientSettings = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.patientSettings,
  );
  const ageProperties = patientSettings?.items?.find(
    (item) => item.name === 'age',
  );
  let { unitProperties } = ageProperties || {};
  let navigate = useNavigate();
  const onSuccess = (data) => {
    // toast.success(data.message, {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
    if (data?.sendSMSStatus === 2) {
      setLoadingStatus(false);
      setBalanceMessage(
        'Appointment was created successfully but SMS notification was not sent due to insufficient SMS balance',
      );
    } else {
      navigate('/appointments');
    }
  };
  const onError = (error) => {
    setLoadingStatus(false);
    setBackendError(error.message);
  };

  const deletePatientImage = () => {
    if (patientPicture) {
      const confirmDelete = window.confirm(
        'Are you sure you want to delete this image?',
      );
      // Proceed with deletion if confirmed
      if (confirmDelete) {
        deleteRequest(`auth/patient-img-delete/${patientInfo.id}`)
          .then((res) => {
            console.log(res, 'deletePatientImage');
          })
          .catch((error) => {});
      }
    } else {
      setImageSrc(null);
    }
  };

  const { isLoading: isProfilePictureLoading, refetch: getProfilePicture } =
    useGetRequest(
      `get-patient-imgage/${patientId}`,
      `auth/patient-picture/${patientId}`,
      (data) => {
        setPatientPicture(data);
        console.log(data);
      },
      (e) => {
        console.log('error message: ', e.message);
      },
    );

  const getPatientIdForDoctor = (idList) => {
    let patientId = '';
    idList?.forEach((item) => {
      if (item.doctorId === userInfo.id) {
        patientId = item.patientId;
      }
    });
    return patientId;
  };

  useEffect(() => {
    if (patientId) getProfilePicture();
  }, [patientId]);

  useEffect(() => {
    const doctorPatientId = getPatientIdForDoctor(
      patientInfo?.patientIdForDoctor,
      userInfo,
    );
    console.log('working for patient Id : test patientId', patientInfo);
    setDoctorPatientId(doctorPatientId);
  }, [patientInfo]);

  const { isPatientLoading, mutate: submitUser } = usePostRequest(
    'appointments/appointment-with-patient',
    {
      pid: patientInfo?.id,
      name: patientInfo.name,
      //dob: ageOrDob ? dob : ageConvertToDateTime(dob),
      dob: patientInfo.dob,
      phoneNumber: patientInfo.phoneNumber
        ? patientInfo.phoneNumber
        : phoneNumber,
      gender: patientInfo.gender ? patientInfo.gender : 'male',
      address: patientInfo?.patientDetails?.address,
      email: patientInfo?.email,
      appointmentDateTime: appointmentDateTime,
      visitType: visitType,
      serialNumber: patientInfo?.serialNumber,
      fee: parseInt(visitationFee),
      generalExaminations: selectedOnExamination?.generalExaminations,
      chiefComplains: selectedChiefComplains,
      investigations: selectedInvestigations,
      nid: patientInfo?.patientDetails?.nid,
      reference_by: patientInfo?.patientDetails?.reference_by,
      registration_no: patientInfo?.patientDetails?.registration_no,
      disease: patientInfo?.patientDetails?.disease,
      image: patientInfo?.image ? patientInfo?.image : null,
      doctorId:
        userRole(userInfo.userType) === 'assistant'
          ? activeDoctor.id
          : userInfo.id,
      organizationId:
        userRole(userInfo.userType) === 'assistant'
          ? userInfo?.organizationIds[0]?.id
          : activeOrganization.id,
      patientType: patientType,
    },
    onSuccess,
    onError,
  );
  const handleSubmit = () => {
    setLoadingStatus(true);
    const { isValid, errors } = validation(
      {
        ...patientInfo,
        birthDate: patientInfo?.dob,
        appointmentDateTime: appointmentDateTime,
      },
      appointmentSchema,
    );
    if (isValid) {
      console.log('scucess submit');
      console.log('data detais; ', appointmentDateTime, patientInfo);
      submitUser();
    }

    if (Object?.keys(errors)?.length !== 0) {
      setErrors(errors);
      setLoadingStatus(false);
    }
  };

  const selectSearchResult = (selectedUser) => {
    setPatientInfo({ ...selectedUser[0] });
    setPatientId(selectedUser[0]?.id);
  };

  const getAvatarImage = () => {
    if (imageSrc) return imageSrc;
    else if (patientPicture) return patientPicture;
    else if (patientInfo?.gender === 'female') return avatarFemale;
    else return avatarMale;
  };

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-md-12 sticky-header shadow header-sticky-second">
            <TopLeftMenu />
          </div>
        </div>
        <Row className="rx-body">
          <div className="col-xl-12 col-md-12 col-lg-12">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <span style={{ width: '25%' }}>
                  <BackArrow
                    className="trash-icon square-back-arrow cursor-pointer"
                    onClick={() => navigate('/appointments')}
                  />{' '}
                  <Link to={'/appointments'} className="back-link-text">
                    {' '}
                    <span>Back to Appointment List</span>
                  </Link>
                </span>
                <h6
                  className="m-0 font-weight-bold center black"
                  style={{ width: '75%' }}
                >
                  New Appointment
                </h6>
              </div>

              <div className="card-body patient-history appointment-card-body">
                <Row>
                  <Col xs={3} sm={3} md={3}></Col>
                  <Col md={12} xs={12} sm={12}>
                    <Form className="appointmentForm mb-4">
                      <div className="v-error text-center">{backendError}</div>
                      <div className="text-center" style={{ color: 'green' }}>
                        {balanceMessage}
                      </div>
                      {/* <div className="add-new-rx mb-3">
                        <span>Add New Appointment </span>
                      </div> */}
                      <div className="row">
                        <div className="col-xl-12 col-lg-12">
                          <div>
                            <div className="patient-history patient-info">
                              <Row>
                                <Col
                                  md={3}
                                  className="patient-details my-2"
                                  style={{ fontSize: '15px' }}
                                >
                                  <div className="card shadow py-3">
                                    <div className="icon-list">
                                      {(patientPicture || imageSrc) && (
                                        <i
                                          className="far fa-times-circle cursor-pointer pr-3"
                                          onClick={() => deletePatientImage()}
                                        ></i>
                                      )}
                                    </div>
                                    <div className="patient-img-info">
                                      {!isOpenCamera ? (
                                        <img
                                          className="profile-img"
                                          alt="Avatar"
                                          src={
                                            patientInfo?.gender === 'female'
                                              ? getAvatarImage()
                                              : getAvatarImage()
                                          }
                                        />
                                      ) : (
                                        <>
                                          <WebcamCapture
                                            imageSrc={imageSrc}
                                            setImageSrc={setImageSrc}
                                            isOpenCamera={isOpenCamera}
                                            patientInfo={patientInfo}
                                            setPatientInfo={setPatientInfo}
                                            setIsOpenCamera={setIsOpenCamera}
                                          />
                                        </>
                                      )}
                                      <div className="patient-name">
                                        {patientInfo?.name}
                                      </div>
                                      {/* <div className="patient-phone-number">{patientInfo?.phoneNumber}</div> */}
                                      {/* <div className="patient-email light-blue-color">
                                        {patientInfo?.email}
                                      </div> */}
                                      <div className="patient-pid mt-2">
                                        <span>Patient ID:</span>
                                        {doctorPatientId}
                                      </div>
                                      <div className="patient-age">
                                        <span>Age:</span>
                                        {agePrint(
                                          separateDateTime(patientInfo?.dob),
                                          unitProperties,
                                        )}
                                      </div>
                                      <div className="center">
                                        <button
                                          className="small-btn mt-2 mb-3"
                                          onClick={(e) => {
                                            setIsOpenCamera(true);
                                            e.preventDefault();
                                          }}
                                        >
                                          Edit Picture
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card shadow py-3 my-3 black hide">
                                    <h4 className="center">Information</h4>
                                    <div>
                                      <span className="information_span pr-2">
                                        Gender:
                                      </span>
                                      {capitalizeFirstLetter(
                                        patientInfo?.gender,
                                      )}
                                    </div>
                                    <div>
                                      <span className="information_span pr-2">
                                        Height:
                                      </span>
                                      {selectedOnExamination
                                        ?.generalExaminations?.heightInfo
                                        ?.feet || 'n/a'}{' '}
                                      {selectedOnExamination
                                        ?.generalExaminations?.heightInfo?.feet
                                        ? 'Ft '
                                        : ''}{' '}
                                      {selectedOnExamination
                                        ?.generalExaminations?.heightInfo
                                        ?.inch || ''}{' '}
                                      {selectedOnExamination.generalExaminations
                                        ?.heightInfo?.inch
                                        ? ' inch'
                                        : ''}
                                    </div>
                                    <div>
                                      <span className="information_span pr-2">
                                        Weight:
                                      </span>
                                      {selectedOnExamination
                                        ?.generalExaminations?.weightInfo
                                        ?.weight
                                        ? selectedOnExamination
                                            .generalExaminations?.weightInfo
                                            ?.weight +
                                          ' ' +
                                          selectedOnExamination
                                            .generalExaminations?.weightInfo
                                            ?.weightUnit
                                        : 'n/a'}
                                    </div>
                                    <div>
                                      <span className="information_span pr-2">
                                        Phone No:
                                      </span>
                                      {patientInfo?.phoneNumber
                                        ? patientInfo?.phoneNumber
                                        : 'n/a'}
                                    </div>
                                    <div>
                                      <span className="information_span pr-2">
                                        Blood Group:{' '}
                                      </span>
                                      {selectedOnExamination
                                        ?.generalExaminations?.bloodGroup ||
                                        'n/a'}
                                    </div>
                                  </div>
                                  {/* <Row className="text-center">
                                    <Col>
                                      <Row>
                                        <Col>
                                          <div className="label-bold">
                                            Gender
                                          </div>
                                          <div className="mt-2">
                                            {capitalizeFirstLetter(
                                              patientInfo?.gender,
                                            )}
                                          </div>
                                          <hr />
                                        </Col>
                                        <Col>
                                          <div className="label-bold">Age</div>
                                          <div className="mt-2">
                                            {agePrint(
                                              separateDateTime(
                                                patientInfo?.dob,
                                              ),
                                              unitProperties,
                                            )}
                                          </div>
                                          <hr />
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="label-bold">
                                            Height
                                          </div>
                                          <div className="mt-2">
                                            {
                                              selectedOnExamination
                                                ?.generalExaminations
                                                ?.heightInfo?.feet
                                            }
                                            {selectedOnExamination
                                              ?.generalExaminations?.heightInfo
                                              ?.inch
                                              ? '.' +
                                                selectedOnExamination
                                                  .generalExaminations
                                                  ?.heightInfo?.inch
                                              : ''}
                                            {selectedOnExamination
                                              ?.generalExaminations?.heightInfo
                                              ?.feet ||
                                            selectedOnExamination
                                              .generalExaminations?.heightInfo
                                              ?.inch
                                              ? ' ' +
                                                selectedOnExamination
                                                  .generalExaminations
                                                  ?.heightInfo?.heightUnit
                                              : ''}
                                          </div>
                                          <hr />
                                        </Col>
                                        <Col>
                                          <div className="label-bold">
                                            Weight
                                          </div>
                                          <div className="mt-2">
                                            {selectedOnExamination
                                              ?.generalExaminations?.weightInfo
                                              ?.weight
                                              ? selectedOnExamination
                                                  .generalExaminations
                                                  ?.weightInfo?.weight +
                                                ' ' +
                                                selectedOnExamination
                                                  .generalExaminations
                                                  ?.weightInfo?.weightUnit
                                              : ''}
                                          </div>
                                          <hr />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row> */}
                                </Col>
                                <Col md={9}>
                                  <Tab.Container
                                    id="left-tabs-example"
                                    defaultActiveKey="basic"
                                    className="pl-4"
                                  >
                                    <Nav
                                      variant="pills"
                                      className="d-flex custom-tab"
                                      style={{
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        cursor: 'none',
                                      }}
                                    >
                                      <Nav.Item className="flex-fill">
                                        <Nav.Link eventKey="basic">
                                          Appointment Details
                                        </Nav.Link>
                                      </Nav.Item>
                                      {/* <Nav.Item className="flex-fill">
                                        <Nav.Link eventKey="medical">
                                          Medical Information
                                        </Nav.Link>
                                      </Nav.Item>
                                      <Nav.Item className="flex-fill">
                                        <Nav.Link eventKey="others">
                                          Others
                                        </Nav.Link>
                                      </Nav.Item> */}
                                    </Nav>
                                    <Tab.Content>
                                      <Tab.Pane
                                        eventKey="basic"
                                        className="card shadow"
                                        style={{
                                          height: '452px',
                                          overflowY: 'auto',
                                          paddingLeft: '10px',
                                          paddingRight: '5px',
                                        }}
                                      >
                                        <BasicPatientForAppointment
                                          patientInfo={patientInfo}
                                          setPatientInfo={setPatientInfo}
                                          selectSearchResult={
                                            selectSearchResult
                                          }
                                          setPhoneNumber={setPhoneNumber}
                                          phoneNumber={phoneNumber}
                                          appointmentInfo={appointmentInfo}
                                          patientType={patientType}
                                          setPatientType={setPatientType}
                                          selectedChiefComplains={
                                            selectedChiefComplains
                                          }
                                          setSelectedChiefComplains={
                                            setSelectedChiefComplains
                                          }
                                          selectedInvestigations={
                                            selectedInvestigations
                                          }
                                          setSelectedInvestigations={
                                            setSelectedInvestigations
                                          }
                                          errors={errors}
                                          setAppointmentDateTime={
                                            setAppointmentDateTime
                                          }
                                          visitType={visitType}
                                          setVisitType={setVisitType}
                                          setVisitationFee={setVisitationFee}
                                          isEdit={false}
                                        />
                                        <MedicalPatientForAppointment
                                          patientInfo={patientInfo}
                                          setPatientInfo={setPatientInfo}
                                          selectedOnExamination={
                                            selectedOnExamination
                                          }
                                          appointmentInfo={appointmentInfo}
                                          setAppointmentDateTime={
                                            setAppointmentDateTime
                                          }
                                          setSelectedOnExamination={
                                            setSelectedOnExamination
                                          }
                                        />

                                        <OthersPatientInfo
                                          patientInfo={patientInfo}
                                          setPatientInfo={setPatientInfo}
                                          appointmentInfo={appointmentInfo}
                                          setAppointmentInfo={
                                            setAppointmentInfo
                                          }
                                        />
                                      </Tab.Pane>
                                      {/* <Tab.Pane eventKey="medical">
                                        <MedicalPatientForAppointment
                                          patientInfo={patientInfo}
                                          setPatientInfo={setPatientInfo}
                                          selectedOnExamination={
                                            selectedOnExamination
                                          }
                                          appointmentInfo={appointmentInfo}
                                          setAppointmentDateTime={
                                            setAppointmentDateTime
                                          }
                                          setSelectedOnExamination={
                                            setSelectedOnExamination
                                          }
                                        />
                                      </Tab.Pane>
                                      <Tab.Pane eventKey="others">
                                        <OthersPatientInfo
                                          patientInfo={patientInfo}
                                          setPatientInfo={setPatientInfo}
                                          appointmentInfo={appointmentInfo}
                                          setAppointmentInfo={
                                            setAppointmentInfo
                                          }
                                        />
                                      </Tab.Pane> */}
                                      <Row className="mt-2 mb-2">
                                        <Col className="text-center">
                                          {loadingStatus ? (
                                            <LoadingButton btnFull="yes" />
                                          ) : (
                                            <Button
                                              variant="primary"
                                              size="sm"
                                              style={{ width: 'inherit' }}
                                              onClick={() => handleSubmit()}
                                            >
                                              <b>
                                                <i className="fa fa-plus-circle"></i>{' '}
                                                Create Appointment
                                              </b>
                                            </Button>
                                          )}
                                        </Col>
                                      </Row>
                                    </Tab.Content>
                                  </Tab.Container>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col nd={3}></Col>
                </Row>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </div>
  );
}

export default PatientHistory;
